import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

export default function (Vue){
	Vue.auth = {
		userStatus(){
		  return new Promise(function (resolve, reject) {
		    firebase.auth().onAuthStateChanged(function (user) {
		      if (user) {
		        resolve(user.uid);
		      } else {
		        reject(Error('It broke'));
		      }
		    });
		  });
		},
		createAccount(dataUser){
			const here = this
	    firebase.auth().createUserWithEmailAndPassword(dataUser.email, dataUser.password)
	      .then(function(data){

	        here.saveUserInfo(data.user.uid, dataUser)
	        here.login(dataUser.email, dataUser.password)

	      })
	      .catch(function(error) {
	      });

		},
		login(email, password){
			firebase.auth().signInWithEmailAndPassword(email, password)
			.then(function(data){
				console.log("Login: ", data)
			})
			.catch(function(error) {
			  console.log("Login error: ", error)
			  // ...
			});
		},
    saveUserInfo(userID, userData){
      let db = firebase.firestore()
      db.collection("users").doc(userID).set({
        nombre: userData.nombre,
        telefono: userData.telefono,
        email: userData.email
      }, { merge: true })
      .then(function() {
          
      })
      .catch(function(error) {
          
      });
    }
	}

	Object.defineProperties(Vue.prototype, {
		$auth: {
			get () {
				return Vue.auth
			}
		}
	})
}